import { doGet } from '../../utils/requests';
import store from '../../reducers';

// const receberErro = () => console.log('receber erro');

const receberGlosas = (retorno) => {
  store.dispatch({
    type: 'GLOSA_RECEBER_GOLSAS_DE_ENTE',
    payload: retorno.data,
  });
};

const receberGlosa = (retorno) => {
  store.dispatch({
    type: 'GLOSA_RECEBER_GOLSA',
    payload: retorno.data,
  });
};

export const solicitarGlosas = (idEnte, competencia) => doGet(
  `glosa-manual/lista-glosas?idSolicitante=${idEnte}&dataCompetencia=${competencia}`,
  receberGlosas,
);

export const solicitarGlosa = idGlosa => doGet(`glosa-manual?idGlosa=${idGlosa}`, receberGlosa);



// WEBPACK FOOTER //
// ./src/pages/glosas/actions.js